/**
 * @generated SignedSource<<4199cf69cdd42d59aefb18b61095d8bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddPlayersStepNode$data = {
  readonly __typename: "QueueSlot";
  readonly requirePlayerCounts?: boolean;
  readonly " $fragmentType": "AddPlayersStepNode";
};
export type AddPlayersStepNode$key = {
  readonly " $data"?: AddPlayersStepNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersStepNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddPlayersStepNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "type": "QueueSlot",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requirePlayerCounts",
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "04d1e3d3761739aebeb8b645b7ce4931";

export default node;
